import LegalShell from "@/components/site/LegalShell";

const sections = [
  {
    h: "1. Information We Collect",
    list: [
      "Information you provide — name, email address, phone number, message content, and any details you share when requesting a consultation, completing forms, or corresponding with us (e.g., portfolio descriptions, asset information).",
      "Automatically collected information — IP address, browser type, device information, pages visited, and usage data via cookies or similar technologies (standard analytics).",
      "From third parties — we do not purchase personal data. Any information from professional referrals or public sources is used only as needed for legitimate advisory purposes.",
    ],
  },
  {
    h: "2. How We Use Your Information",
    body: ["We use information to:"],
    list: [
      "Respond to inquiries and provide consultations or services under written mandates.",
      "Communicate about engagements (yield blueprints, refurbishment oversight, operator selection, etc.).",
      "Improve the Site and our services.",
      "Comply with legal obligations and protect our rights.",
      "Maintain confidentiality as a core principle of our practice.",
    ],
    after:
      "We do not use your information for unrelated marketing without consent, and we never share client details with third parties for their own purposes.",
  },
  {
    h: "3. Cookies and Tracking",
    body: [
      "The Site may use essential cookies for functionality and optional analytics cookies. You can control cookies through your browser settings. We do not use intrusive tracking for advertising.",
    ],
  },
  {
    h: "4. Sharing of Information",
    body: ["We do not sell, rent, or trade personal information. We may share information only:"],
    list: [
      "With service providers who assist us (e.g., secure email or hosting) under strict confidentiality.",
      "When required by law, court order, or to protect rights and safety.",
      "With your explicit consent.",
    ],
    after: "All client work remains confidential. Custody of assets and funds always remains with the owner.",
  },
  {
    h: "5. Data Retention",
    body: [
      "We retain personal information only as long as needed for the purposes described, to fulfill mandates, or as required by law. Contact us to request deletion where applicable.",
    ],
  },
  {
    h: "6. International Transfers",
    body: [
      "We are a Wyoming, USA company serving global clients (including UK property owners). Information may be processed in the United States. We take reasonable steps to protect data consistent with applicable laws, including GDPR where relevant for UK/EEA individuals.",
    ],
  },
  {
    h: "7. Your Rights",
    body: [
      "Depending on your location (including under GDPR for UK/EU residents), you may have rights to access, correct, delete, or restrict processing of your personal data, or to object or withdraw consent. Contact us at info@adi-semaradana.com to exercise these rights. We will respond within applicable legal timeframes.",
    ],
  },
  {
    h: "8. Security",
    body: [
      "We implement reasonable administrative, technical, and physical safeguards to protect information. No method of transmission or storage is 100% secure.",
    ],
  },
  {
    h: "9. Children's Privacy",
    body: [
      "The Site and services are not directed at children under 16. We do not knowingly collect information from them.",
    ],
  },
  {
    h: "10. Changes to This Policy",
    body: [
      "We may update this Privacy Policy. The “Last updated” date will reflect changes. Continued use of the Site constitutes acceptance of the revised policy.",
    ],
  },
  {
    h: "11. Contact Us",
    body: [
      "For privacy questions or requests:",
      "I Putu Adi Semarada LLC · 30 N Gould St Ste R, Sheridan, WY 82801, USA",
      "Email: info@adi-semaradana.com · Phone: +1 888 557 6994",
    ],
  },
];

export default function Privacy() {
  return (
    <LegalShell
      testId="privacy-page"
      title="Privacy Policy"
      updated="November 5, 2026"
      intro="I Putu Adi Semarada LLC (“we,” “us,” or “our”) operates the website www.adi-semaradana.com (the “Site”). This Privacy Policy explains how we collect, use, disclose, and protect information when you visit the Site or engage with our independent owner-side property consulting services. We provide advisory counsel only — we do not sell, let, or manage properties. All engagements are confidential and governed by written mandates."
      sections={sections}
    />
  );
}
